import { render, staticRenderFns } from "./StaffList.vue?vue&type=template&id=265325ce&scoped=true"
import script from "./StaffList.vue?vue&type=script&lang=js"
export * from "./StaffList.vue?vue&type=script&lang=js"
import style0 from "./StaffList.vue?vue&type=style&index=0&id=265325ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265325ce",
  null
  
)

export default component.exports